import type { MultiBrandConfig } from './types';

// Website 07 — Re-digital Neon / Dark Premium storefront. App-first, premium,
// tech-forward connectivity brand: near-black UI, mint→cyan neon accents, an
// app DASHBOARD aesthetic (data-balance, usage meter, top-up, account control)
// and global/regional-plan-first navigation. The highest-margin, app-candidate
// brand (neon-night / neon-day palettes). Name/domain PROVISIONAL.
//
// DOMAIN NOTE: points at esimsupra.com for now because every storefront shares
// ONE backend (functions/ + billing worker + D1). Needs its own canonical
// domain + contact email before launch. Build-selectable for preview only
// (BRAND_ID=redigital-neon-dark-premium).
//
// NO-FAKE-APP: strategy §10 forbids advertising app features that don't exist.
// The dashboard is presented as a product VISUAL + "app coming soon" framing.
// No SoftwareApplication schema, no working store-download links.
//
// CLAIM-SAFETY: the mockups are saturated with unverifiable proof (Trustpilot
// 4.8/5, 18k+ reviews, 250k+ travelers, Google/App Store ratings). NONE are
// reproduced. Social proof is rebuilt with neutral, supportable copy only.
export const redigitalNeon: MultiBrandConfig = {
  id: 'redigital-neon-dark-premium',
  status: 'provisional',
  siteType: 'storefront',
  positioning:
    'App-first, dark-premium travel eSIM for tech-savvy travelers, digital nomads and remote workers who value control, design and global/regional coverage over the lowest price — data balance, usage and top-up storytelling in a modern connectivity-app aesthetic.',
  theme: {
    mode: 'dark', // near-black premium dashboard, dark-first
    defaultDark: 'neon-night',
    defaultLight: 'neon-day',
  },
  checkoutEnabled: true,
  // App-first premium brand: lead with global/regional plans. Presentation only.
  pricingDisplayMode: 'app-global-first',
  legacy: {
    brand: {
      name: 'Re-digital',
      displayName: 'Re-digital',
      tagline: 'Global connectivity, one tap away',
      description:
        'Premium travel eSIM data for modern travelers. Choose a global, regional or country plan, pay securely, and get your eSIM by email instantly — with a control-center view of your data, validity and top-ups. No plastic, no roaming surprises.',
      logo: '/images/assets/logo.svg',
      logoAlt: 'Re-digital Logo',
    },
    contact: {
      // TODO(brand-email): planned dedicated inbox `hello@esimmidnight.com` (TBD) before indexed launch (R14). Shared inbox for now.
      email: 'contact@esimsupra.com',
      phone: '',
      phoneFormatted: '',
      whatsapp: '',
      address: 'Available Worldwide',
      supportHours: '24/7 Support',
    },
    website: {
      url: 'https://esimsupra.com',
      domain: 'esimsupra.com',
    },
    social: {
      facebook: '',
      twitter: '',
      instagram: '',
      youtube: '',
      telegram: '',
    },
    resources: {
      compatibilityUrl: '#',
      compatibilityLabel: 'Check Device Compatibility',
    },
    legal: {
      copyrightYear: new Date().getFullYear().toString(),
      copyrightText: `© ${new Date().getFullYear()} Re-digital. All rights reserved.`,
    },
    features: {
      count180Countries: '200+ Destinations',
      uptimePerformance: 'Fast 4G/5G',
      support247: '24/7 Support',
    },
    ui: {
      theme_palette_selector: true,
    },
  },
  tech: {
    analytics: {
      gtmId: 'TBD — provision per-brand GTM container ID in Google Tag Manager',
      ga4Id: 'TBD — provision per-brand GA4 measurement ID in Google Analytics',
      metaPixelId: 'TBD — provision per-brand Pixel ID in Meta Events Manager',
      googleAdsConversionId: 'TBD — provision per-brand conversion ID in Google Ads',
      googleAdsPurchaseLabel: 'TBD — provision per-brand purchase conversion label in Google Ads',
    },
    trustpilot: {
      businessUnitId: 'TBD — create Trustpilot Business Unit for esimmidnight.com',
      locale: 'en-US',
    },
    stripe: {
      statementDescriptorSuffix: 'REDIG',
      accountId: 'TBD — create Stripe Connect account or use statement_descriptor_suffix on shared account',
    },
    canonical: {
      domain: 'esimmidnight.com',
      url: 'https://esimmidnight.com',
      organizationLegalName: 'TBD — register legal entity for Re-digital',
    },
    llms: {
      tagline: 'Data control for the always-on traveler',
      audience: 'Digital nomads and tech-forward travelers who want dashboard-style data control and global/regional plans.',
    },
  },
};

export default redigitalNeon;
